import { ResolverTag } from '@ps/web-core-enums';
import { useResolver } from '@ps/web-shared-components';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';

interface Handler {
  scriptTags: HTMLScriptElement[];
}

const ScriptLoader: React.FC = () => {
  const [scriptLoad, setScriptLoad] = useState(false);
  const location = useLocation();
  const isClientAuthenticated = useSelector(select.session.isClientAuthenticated);
  const brandName = useSelector(select.cms.getBrandName);
  const ipCountry = useSelector(select.country.getCountry);
  const locale = useSelector(select.locale.get);
  const siteName = useSelector(select.cms.getSiteName);
  const hostname = useSelector(select.location.getHostname);
  const scriptSource = useResolver(ResolverTag.PSMessenger);
  const shouldOpenMessenger = useSelector(select.help.getShouldOpenMessenger);
  const userInfo = useSelector(select.help.getUserInfo);
  const { openChat } = useSelector(select.help.get);
  const { modal } = useDispatch<Dispatch>();

  useEffect(() => {
    window.lpTagMgr?.newPage();
  }, [location]);

  useEffect(() => {
    if (isClientAuthenticated) {
      if (userInfo && scriptLoad) {
        window.lpTagMgr?.onLoggedIn(userInfo);
      }
    } else {
      window.lpTagMgr?.onLoggedOut();
    }
  }, [isClientAuthenticated, scriptLoad, userInfo]);

  useEffect(() => {
    if (isClientAuthenticated && openChat) {
      modal.close();
      window.lpTagMgr?.openAuthenticatedChat();
    }
  }, [isClientAuthenticated, modal, openChat]);

  const handleScriptInject = ({ scriptTags }: Handler) => {
    if (scriptTags) {
      const script = scriptTags.find((s) => s.src === scriptSource);
      if (script) {
        script.onload = () => {
          window.lpTagMgr?.initialize({
            userInfo,
            siteInfo: {
              brand: brandName,
              locale,
              site: siteName,
              ipCountry,
              domain: hostname
            }
          });

          setScriptLoad(true);
        };
      }
    }
  };

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {shouldOpenMessenger && (
        <Helmet
          script={[{ src: scriptSource }]}
          onChangeClientState={(newState, { scriptTags }) => handleScriptInject({ scriptTags })}
        />
      )}
    </>
  );
};

export default ScriptLoader;
